"use strict";
/// <reference path="../../../../Trillium.UI/TypeScript/Models/Website/BannerSlideItemComponentViewModel.tsx"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var BannerSlideItemComponent = /** @class */ (function (_super) {
    __extends(BannerSlideItemComponent, _super);
    function BannerSlideItemComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BannerSlideItemComponent.prototype.render = function () {
        var hasLink = this.props.LinkTitle !== '' && this.props.LinkUrl !== '';
        var button;
        if (hasLink) {
            button = react_1.default.createElement("a", { href: this.props.LinkUrl, className: "btn btn-primary" }, this.props.LinkTitle);
        }
        return react_1.default.createElement("div", { className: this.props.IsActive ? 'carousel-item active' : 'carousel-item' },
            react_1.default.createElement("img", { className: "d-block w-100", src: this.props.ImageUrl, alt: "" }),
            react_1.default.createElement("div", { className: "imgBanner" }),
            react_1.default.createElement("div", { className: "content" },
                react_1.default.createElement("div", { className: "content-text" },
                    react_1.default.createElement("h2", null, this.props.Header),
                    react_1.default.createElement("p", null, this.props.Description),
                    button)));
    };
    return BannerSlideItemComponent;
}(react_1.default.Component));
exports.default = BannerSlideItemComponent;
